// src/config/maps.js

export const MAPS_CONFIG = {
  apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || null,
  libraries: ['places', 'geometry']
};

export const MAP_DEFAULTS = {
  center: {
    lat: 37.7749,
    lng: -122.4194
  },
  zoom: 12
};

// Maps configuration
// To use Mapbox maps, add your public Mapbox token here
// Get a free token at: https://docs.mapbox.com/help/getting-started/access-tokens/

export const MAPBOX_CONFIG = {
  // Replace with your Mapbox public token (starts with 'pk.')
  ACCESS_TOKEN: import.meta.env.VITE_MAPBOX_TOKEN || null,

  // Default map style
  DEFAULT_STYLE: 'mapbox://styles/mapbox/light-v11',

  // Default center coordinates (US center)
  DEFAULT_CENTER: [-98.5795, 39.8283],

  // Default zoom level
  DEFAULT_ZOOM: 4
};

// Helper function to check if Mapbox is available
export const isMapboxAvailable = () => {
  return MAPBOX_CONFIG.ACCESS_TOKEN && MAPBOX_CONFIG.ACCESS_TOKEN.startsWith('pk.');
};

// Helper function to check if Google Maps is available
export const isGoogleMapsAvailable = () => {
  return MAPS_CONFIG.apiKey !== null;
};